<template>
  <span
    :class="badgeClass"
    :title="title">
    <span class="f-badge-text">
      <slot/>
    </span>
    <f-time-elapsed
      v-if="counter"
      class="ml-1"
      :minimal="true"
      :time="counter"/>
  </span>
</template>
<script>

export default {
  name: 'f-badge',
  props: {
    big: {
      type: Boolean,
      default: false
    },
    checkable: {
      type: Boolean,
      default: false
    },
    checkboxModel: {
      type: String,
      default: null
    },
    counter: {
      type: String,
      default: null
    },
    counterExceeded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: 'dark',
      validator: v => ['unfinished-form', 'sent', 'sent-not-open', 'cancelled', 'realized', 'waiting-for-offer', 'awaiting-contact', 'in-realization', 'new', 'dark', 'light', 'draft', 'invited', 'invitation-confirmed', 'primary', 'success', 'danger'].includes(v)
    },
  },
  computed: {
    badgeClass () {
      let badgeCSSClass = ['f-badge'];

      if (this.theme) {
        badgeCSSClass.push(`f-badge-${this.theme}`);
      }

      if (this.checkable) {
        badgeCSSClass.push('f-badge-checkbox');
      }

      if (this.big) {
        badgeCSSClass.push('f-badge-big');
      }

      if (this.disabled) {
        badgeCSSClass.push('f-badge-disabled');
      }

      return badgeCSSClass.join(' ');
    }
  }
}
</script>
